<template>
  <!-- Pre-program content -->
  <main role="main" class="container">
    <div class="text-center py-md-5 px-md-4 py-3">
      <h1 class="text-center mb-3" v-html="$t('PostProgram.ProgramEndedTitle')">

      </h1>
      <div v-html="$t('PostProgram.ProgramEndedDesc')"></div>

      <a :href="$t('PostProgram.ButtonLink')" target="_blank" class="btn btn-link mt-4 mb-4 px-5 py-2"
        v-html="$t('PostProgram.Button')" :aria-label="$t('PostProgram.Button') + ' (opens in a new tab)'">

      </a>
    </div>
  </main>
</template>
<script>
export default {
  props: {
    endDate: {
      type: Date,
      required: true,
    },
  },
};
</script>
